// This is just for the Loading or Error Selector
export const GET_ENGINEERS = 'GET_ENGINEERS';

// Use these for Actions
export const GET_ENGINEERS_REQUEST = 'GET_ENGINEERS_REQUEST';
export const GET_ENGINEERS_SUCCESS = 'GET_ENGINEERS_SUCCESS';
export const GET_ENGINEERS_ERROR = 'GET_ENGINEERS_ERROR';
